module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-cms-structure-dropdown d-inline-block"
  }, [_c('div', {
    staticClass: "dropdown-label-box d-inline-block my-2 my-lg-0"
  }, [_c('div', {
    class: ['dropdown', 'btn-group', {
      'show': _vm.visible
    }]
  }, [_c('button', {
    ref: "mainDropdownButton",
    staticClass: "btn btn-secondary dropdown-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleButtonClick,
      "blur": _vm.handleBlur
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": _vm.lightscoutURL,
      "role": "menuitem"
    }
  }, [_vm._v("\n\t\t\t\t   Live-Auswahl\n\t\t\t\t")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleSubmenuItemClick,
      "blur": _vm.handleBlur
    }
  }, [_vm._v("\n\t\t\t\t   CMS-Struktur\n\t\t\t\t\t"), _c('div', {
    staticClass: "dropdown dropdown-sub btn-group"
  }, [_c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('a', {
    staticClass: "dropdown-item -muted text-muted",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleSubmenuItemClick,
      "blur": _vm.handleBlur
    }
  }, [_c('strong', [_vm._v("Bereich")])]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item dropdown-static-item",
    attrs: {
      "href": "javascript: void(0);",
      "role": "menuitem"
    },
    on: {
      "click": _vm.handleResetClick
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t   Auswahl zurücksetzen\n\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.dataset), function(category, cIndex) {
    return _c('a', {
      key: cIndex,
      class: ['dropdown-item', 'dropdown-multilevel-item', {
        '-active': _vm.itemIsActive({
          category: category.name
        })
      }],
      attrs: {
        "href": "javascript: void(0);",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_c('div', {
      staticClass: "dropdown dropdown-sub"
    }, [_c('a', {
      staticClass: "dropdown-item",
      attrs: {
        "aria-disabled": "false",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(category.name) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "role": "menu"
      }
    }, [_c('a', {
      staticClass: "dropdown-item -muted text-muted",
      attrs: {
        "href": "javascript: void(0);",
        "role": "menuitem"
      },
      on: {
        "click": _vm.handleSubmenuItemClick,
        "blur": _vm.handleBlur
      }
    }, [_c('strong', [_vm._v("Spezifikation")])]), _vm._v(" "), _vm._l((category.spezifikationen), function(specification, sIndex) {
      return _c('a', {
        key: sIndex,
        class: ['dropdown-item', 'dropdown-multilevel-item', {
          '-active': _vm.itemIsActive({
            category: category.name,
            specification: specification.name
          })
        }],
        attrs: {
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_c('div', {
        staticClass: "dropdown dropdown-sub"
      }, [_c('a', {
        staticClass: "dropdown-item",
        attrs: {
          "href": "javascript: void(0);",
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(specification.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
        staticClass: "dropdown-menu -last",
        attrs: {
          "role": "menu"
        }
      }, [_c('a', {
        staticClass: "dropdown-item -muted text-muted",
        attrs: {
          "href": "javascript: void(0);",
          "role": "menuitem"
        },
        on: {
          "click": _vm.handleSubmenuItemClick,
          "blur": _vm.handleBlur
        }
      }, [_c('strong', [_vm._v("Gattung")])]), _vm._v(" "), _vm._l((specification.gattungen), function(genus, gIndex) {
        return _c('a', {
          key: gIndex,
          class: ['dropdown-item', 'dropdown-last-item', {
            '-active': _vm.itemIsActive({
              category: category.name,
              specification: specification.name,
              genus: genus.name
            })
          }],
          attrs: {
            "href": "javascript: void(0);",
            "role": "menuitem"
          },
          on: {
            "mousedown": function($event) {
              _vm.handleGenusClick(category.name, specification.name, genus.name, $event)
            }
          }
        }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(genus.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])
      })], 2)])])
    })], 2)])])
  })], 2)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-010956b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoCmsStructureDropdown.vue
// module id = 586
// module chunks = 0